import React from "react";

// Import Ionic
import { IonButton, IonCard, IonCardContent, IonCol, IonRow } from "@ionic/react";
import { currencyTransform } from "../../../providers/Redux/Reducers/reducers2";
import { CouponDiscountType } from "@core/types";
import { useTranslation } from "react-i18next";

interface ICouponDetail {
  amount: string | number;
  couponCode: string;
  discountType: any;
  onRemoveClick: () => void;
}

// Детальная информация о купоне
// Временно не отображается
const CouponDetail: React.FC<ICouponDetail> = ({ amount, couponCode, discountType, onRemoveClick }) => {
  const { t } = useTranslation();
  return (
    <IonCard className="card-product">
      <IonCardContent>
        <IonRow>
          <IonCol size="6">{t("Coupon Code")}</IonCol>
          <IonCol size="6" class="ion-text-right">
            {couponCode}
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="6">{t("Coupon Amount")}</IonCol>
          <IonCol size="6" class="ion-text-right">
            {discountType === CouponDiscountType.PERCENT
              ? `%${parseFloat(String(amount)).toFixed(2)}`
              : currencyTransform(amount)}
          </IonCol>
        </IonRow>
        <IonRow>
          {discountType === CouponDiscountType.PERCENT && (
            <IonCol size="12">{t("A percentage discount for the entire cart")}</IonCol>
          )}
          {discountType === CouponDiscountType.FIXED_CART && (
            <IonCol size="12">{t("A fixed total discount for the entire cart")}</IonCol>
          )}
          {discountType === CouponDiscountType.FIXED_PRODUCT && (
            <IonCol size="12">{t("A fixed total discount for selected products only")}</IonCol>
          )}

          <IonCol size="12">
            <IonButton size="small" color="secondary" onClick={onRemoveClick}>
              {t("Remove")}
            </IonButton>
          </IonCol>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};

export default CouponDetail;
